import { RemoI18n, RemoI18nLanguages } from "@obsbot/remo-i18n";
import {
    useGlobalStore,
    getLSPreferencesStore,
    globalStore,
    getPreferencesStore,
} from "@obsbot/remo-stores";
import { RemoServices } from "@obsbot/remo-services";
// import { ipcAsyncByApp } from "../utils/ipc";
import { TencentRTCWeb } from "@obsbot/remo-service-provider-tencent-rtc-web";
import { ServerRegionConfigResult } from "@obsbot/remo-server-api";

let isLoad = false;

export function initRemoServices(): void {
    const init = (config: ServerRegionConfigResult): void => {
        const remoServices = RemoServices.getInstance();
        const videoChatWebInstance: TencentRTCWeb | null = null;
        const appId = config.tencent?.appId;
        remoServices.register("videoChat", () => {
            return new Promise(resolve => {
                if (videoChatWebInstance) {
                    resolve(videoChatWebInstance);
                    return;
                }
                const instance = new TencentRTCWeb({ appId: appId });
                resolve(instance);
            });
        });
        remoServices.register("textChat", async () => {
            const APP_ID = config.tencent?.appId;
            const { TencentRTM } = await import("@obsbot/remo-service-provider-tencent-rtm");
            return new TencentRTM(APP_ID);
        });
    };
    const config = globalStore.getRegionConfig();
    if (config) {
        init(config);
    }
    useGlobalStore.subscribe(state => {
        const config = state.getRegionConfig();
        if (config && !isLoad) {
            isLoad = true;
            init(config);
        }
        if (state.userInfo) {
            // 如果没有设置过LocalStorage, 就设置一个默认值, 使其将PreferencesStore写入到LocalStorage中
            const uid = state.userInfo.user_id;
            const lsPreferencesStore = getLSPreferencesStore(uid);
            if (!lsPreferencesStore) {
                const preferencesStore = getPreferencesStore(uid);
                preferencesStore.updateAlwaysPreviewCam(true);
                const language = navigator.language;
                let curLanguage: RemoI18nLanguages = "zh-CN";
                if (language === "zh-CN") {
                    curLanguage = "zh-CN";
                } else if (language.startsWith("zh-")) {
                    curLanguage = "zh-Hant";
                } else {
                    curLanguage = "en";
                }
                preferencesStore.updateLanguage(curLanguage);
            }
        }
    });

    RemoI18n.getInstance();
}
